import { profileSDK } from 'Utils/ProfileSDK';
import { logger } from 'Utils/Logger';
import { capitalizeFirstLetter } from 'Utils/Format';
import { getTokenExpirations, getUser } from 'Utils/UserCookie';
import { createApiTokenHandler } from 'Utils/Api/RefreshTokenHandler';

//API calls from Profile SDK

export const updateUser = (user) =>
  createApiTokenHandler(async (fetchNewToken) => {
    logger.apiRequest('update user');
    let res;
    try {
      res = await profileSDK().update(user);
    } catch (e) {
      logger.apiError('update user', null, e);
      if (e.statusCode === 401) return fetchNewToken();
      res = e;
    }
    logger.apiResponse('update user');
    return res;
  });

export const checkExistingUser = (email) =>
  createApiTokenHandler(async (fetchNewToken) => {
    logger.apiRequest('check existing user');
    let res;
    try {
      res = await profileSDK().status({ email });
    } catch (e) {
      logger.apiError('check existing user', null, e);
      if (e.statusCode === 401) return fetchNewToken();
      throw e;
    }
    logger.apiResponse('check existing user');
    return res;
  });

export const resetEmail = async (email) =>
  createApiTokenHandler(async (fetchNewToken) => {
    logger.apiRequest('reset email');
    let res;
    try {
      res = await profileSDK().resetPassword({ email });
      logger.apiResponse('reset email', res);
      res = res && res.message && res.message === 'Reset Email Sent' ? true : res.message;
    } catch (e) {
      const errorMessage = e.errorMessage ? `${e.statusCode}: ${capitalizeFirstLetter(e.errorMessage)}` : e.message;
      logger.apiError('reset email', null, e);
      res = errorMessage;
      if (e.statusCode === 401) return fetchNewToken();
    }
    return res;
  });

export const registerSecondScreenCode = (code) =>
  createApiTokenHandler((fetchNewToken) => {
    logger.apiRequest('register second screen code', code);
    return profileSDK()
      .userLoggedInOrRegistered({ regCode: code, isRegister: true })
      .then((res) => {
        logger.apiResponse('register second screen code', res);
        return res;
      })
      .catch((error) => {
        console.error(error.message);
        logger.apiError('register second screen code', null, error.message);
        if (error.statusCode === 401) return fetchNewToken();
        return { error: error.message };
      });
  });

export const fetchMobileRegcode = (deviceId) =>
  createApiTokenHandler((fetchNewToken) => {
    logger.apiRequest('fetch mobile regcode', deviceId);
    return profileSDK()
      .regCodeDeeplink({ deviceId })
      .then((res) => {
        logger.apiResponse('fetch mobile regcode', res);
        return res;
      })
      .catch((error) => {
        console.error(error.message);
        logger.apiError('fetch mobile regcode', null, error.message);
        if (error.statusCode === 401) return fetchNewToken();
        return { error: error.message };
      });
  });

export const login = ({ email, password, recaptchaToken, deviceId, mvpd, mvpdHash }) => {
  logger.apiRequest('login');
  return profileSDK()
    .login({ email, password, recaptchaToken, deviceId, mvpd, mvpdHash })
    .then((res) => {
      /*TODO: CLEAN UP */
      const expirations = getTokenExpirations(res.tokenExpiration);
      return { ...res, ...expirations };
    });
};

export const logout = async () => {
  try {
    const user = getUser();
    let { refreshToken } = user;
    logger.apiRequest('logout');
    const result = await profileSDK().logout({ refreshTokenHint: refreshToken });
    logger.apiResponse('logout', result);
    return result;
  } catch (error) {
    logger.apiError('logout', null, error.message);
    return { error: true };
  }
};

export const checkRefreshToken = ({ accessTokenExpiration, refreshToken }) => {
  logger.apiRequest('check refresh token');
  return profileSDK()
    .checkRefreshToken({ tokenExpiration: accessTokenExpiration, refreshToken })
    .then((res) => {
      logger.apiResponse('check refresh token', res);
      /*TODO: CLEAN UP */
      const expirations = getTokenExpirations(res.tokenExpiration);
      return { ...res, ...expirations };
    })
    .catch((error) => {
      console.error(error.message);
      logger.apiError('check refresh token', null, error.message);
      return { error: error.message };
    });
};
